import Routes from "./Routes";
import { TranslationProvider } from './components/Translation';

export default function App() {
  return (
        <TranslationProvider>
          <Routes />
        </TranslationProvider>
    );
}